import PropTypes from 'prop-types';
import React from 'react';
import Layout from '../../../components/Layout';

class Home extends React.Component {

  render() {
    return (
      <Layout>
        <div className="content-tours">
          <div className="panel">
            <h1>Welcome to Use Catch!</h1>
            <div>Thanks for visting. Nothing to see here now.</div>
            <div><a href="mailto:info@usecatch.com">Contact us</a> if you need access to a tour or travel agency?</div>
          </div>
        </div>
      </Layout>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// src/routes/home/components/TourManagerHome.js